import { HttpClient, HttpParams } from '@angular/common/http';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';

import { SecurityService } from 'app/core/security/security.service';
import { SystemMessage } from 'app/core/system-message/system-message-service';
import { QuickNavOrgVm } from 'app/shared/generated/Administration/Models/Users/QuickNavOrgVm';
import { ResizableWidgetComponent } from '../resizable-widget/resizable-widget.component';

@Component({
    selector: 'pcg-org-quick-nav-widget'
    , imports: [
        ResizableWidgetComponent
    ]
    , templateUrl: './org-quick-nav-widget.component.html'
    , styleUrls: ['./org-quick-nav-widget.component.scss',
        '../resizable-widget/resizable-widget.component.scss'
    ]
    , changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrgQuickNavWidgetComponent {
    private readonly http = inject(HttpClient);
    private readonly router = inject(Router);
    private readonly sec = inject(SecurityService);
    private readonly cdr = inject(ChangeDetectorRef);

    readonly isLoading = signal(true);
    private orgs: QuickNavOrgVm[] = [];
    readonly filteredOrgs = signal<QuickNavOrgVm[]>([]);
    peruseOrgId = -1;

    ngOnInit() { this.initialize(); }

    pressEnter(searchStr: string): void { this.router.navigateByUrl(`admin/organizations/orgs/list?query=${searchStr}`); }

    filterOrgs(searchStr: string): void {
        this.peruseOrgId = -1;
        if (searchStr) {
            const lower = searchStr.toLowerCase();
            this.filteredOrgs.set(this.orgs.filter(org =>
                org.name?.toLowerCase().includes(lower)
                || org.phoneNumber?.toLowerCase().includes(lower)
                || org.glns?.some(gln => gln.toLowerCase().includes(lower))
                || org.address?.toLowerCase().includes(lower),
            ));
        } else {
            this.filteredOrgs.set([]);
        }
    }

    peruseOrgs(event: KeyboardEvent): void {
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            if (this.peruseOrgId !== this.filteredOrgs().length - 1) { this.peruseOrgId++; }
            const el = document.getElementById('org' + this.peruseOrgId.toString());
            if (el) { el.focus(); }
        }
        if (event.key === 'ArrowUp') {
            event.preventDefault();
            if (this.peruseOrgId !== 0) { this.peruseOrgId--; }
            const el = document.getElementById('org' + this.peruseOrgId.toString());
            if (el) { el.focus(); }
        }
        if (event.key === 'Tab') {
            if (event.shiftKey) {
                if (this.peruseOrgId !== 0) { this.peruseOrgId--; }
            } else if (this.peruseOrgId !== this.filteredOrgs().length - 1) { this.peruseOrgId++; }
        }
    }

    redirect(org: QuickNavOrgVm): void {
        this.router.navigateByUrl(`admin/organizations/orgs/edit/${org.organizationId}?tab=Details`);
    }

    private initialize(): void {
        const userId = this.sec.getUser().id;
        const params = new HttpParams().set('userId', userId);
        this.http.get<SystemMessage>('api/Admin/Widgets/GetOrgsForQuickNav', { params })
            .subscribe({
                next: (msg) => {
                    this.orgs = msg.model;
                    this.isLoading.set(false);
                    this.cdr.markForCheck();
                }
                , error: (error) => {
                    console.error('Error fetching organizations:', error);
                    this.isLoading.set(false);
                    this.cdr.markForCheck();
                }
            }
        );
    }
}
